import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/pro-solid-svg-icons";
import classNames from "classnames";

import UploadedFile from "./UploadedFile";
import { FileData } from "../../../../@types/files";

interface SortableUploadedFileProps {
  id: string;
  file: FileData & { extension: string };
  remove: (criteria: { [key: string]: string }) => void;
  storageDirectory?: string;
  isImage?: boolean;
}

export default function SortableUploadedFile({
  id,
  file,
  remove,
  storageDirectory,
  isImage,
}: SortableUploadedFileProps) {
  const isDisabled = file.state === "uploading" || file.state === "failed";

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: isDisabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 1 : 0,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={classNames("flex items-center", {
        "opacity-50": isDragging,
      })}
    >
      <span
        {...attributes}
        {...listeners}
        className={classNames(
          "flex items-center px-1 self-stretch touch-manipulation",
          isDisabled
            ? "text-neutral/50 cursor-default"
            : "text-neutral cursor-grab",
        )}
      >
        <FontAwesomeIcon icon={faGripVertical} />
      </span>
      <div className="flex-1 min-w-0">
        <UploadedFile
          file={file}
          remove={remove}
          storageDirectory={storageDirectory}
          isImage={isImage}
        />
      </div>
    </div>
  );
}
